export default __webpack_public_path__ + "static/media/inner-automated-material-flow.97f04c70.svg";